import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { SvgVddMapping } from '../../../projects/client';

import { HydraulicSchematicActions } from './hydraulic-schematic.actions';
import { HydraulicSchematicSelectors } from './hydraulic-schematic.selectors';

@Injectable({ providedIn: 'root' })
export class HydraulicSchematicStore {
  constructor(private store: Store) {}

  hydraulicSchemeLoading$: Observable<boolean> = this.store.select(
    HydraulicSchematicSelectors.isLoading
  );

  getHydraulicSchematicVdds$: Observable<SvgVddMapping[]> = this.store.select(
    HydraulicSchematicSelectors.getHydraulicSchematicVddsWithMapping
  );

  getHydraulicSchematic$: Observable<any> = this.store.select(
    HydraulicSchematicSelectors.getHydraulicSchematic
  );

  isHydraulicSchematicError$: Observable<boolean> = this.store.select(
    HydraulicSchematicSelectors.isHydraulicSchematicError
  );

  downloadHydraulicSchematic(
    hydraMatrixCode: string,
    bundleId: string,
    isInternalScheme: boolean
  ): void {
    this.store.dispatch(
      HydraulicSchematicActions.getHydraulicSchematic.attempt({
        hydraMatrixCode,
        bundleId,
        isInternalScheme,
      })
    );
  }

  clearState(): void {
    this.store.dispatch(HydraulicSchematicActions.clearState());
  }

  downloadHydraulicSchematicMapping(): void {
    this.store.dispatch(HydraulicSchematicActions.getHydraulicSchematicMapping.attempt());
  }

  isAnyFromHydraulicSchematicVddLoading(): Observable<boolean> {
    return this.store.select(HydraulicSchematicSelectors.isAnyFromHydraulicSchematicVddLoading);
  }

  triggerReadVddValuesForSvg(gatewaySerial: string): void {
    this.store.dispatch(HydraulicSchematicActions.triggerReadVddValuesForSvg({ gatewaySerial }));
  }
}
